import { render, staticRenderFns } from "./M_systemConfigure.vue?vue&type=template&id=106d1ad5&scoped=true&"
import script from "./M_systemConfigure.vue?vue&type=script&lang=js&"
export * from "./M_systemConfigure.vue?vue&type=script&lang=js&"
import style0 from "./M_systemConfigure.vue?vue&type=style&index=0&id=106d1ad5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d1ad5",
  null
  
)

export default component.exports